import '@fingo/lib/assets/fonts/itau/fonts.css';
import { REQUESTING_PLATFORM_TO_CODES } from '@fingo/lib/constants/requesting-platform';
import itauPalette from '@fingo/lib/theme/itau/palette';
import fingoComponents from '@fingo/lib/theme/fingo/components';
import itauComponents from '@fingo/lib/theme/itau/components';
import itauTypography from '@fingo/lib/theme/itau/typography';
import fingoBranding from '@fingo/lib/theme/fingo/branding';
import ThemeStrategy from './ThemeStrategy';

class ItauThemeStrategy extends ThemeStrategy {
  constructor() {
    super();
    this.platformCode = REQUESTING_PLATFORM_TO_CODES.ITAU;
    this.palette = itauPalette;
    this.components = {
      ...fingoComponents,
      ...itauComponents,
    };
    this.typography = itauTypography;
    this.branding = fingoBranding;
  }

  getPlatformCode() {
    return this.platformCode;
  }

  getPalette() {
    return this.palette;
  }

  getComponents() {
    return this.components;
  }

  getTypography() {
    return this.typography;
  }

  getBranding() {
    return this.branding;
  }
}

export default ItauThemeStrategy;
